import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import useUI from 'hooks/use-ui';
import useTranslation from 'hooks/use-translation';
import { useConsentManagement } from 'src/utils/fides/hooks/use-consent-management';

import { ARIA_ROLES } from 'shared/constants';
import { EmbeddedExternalLink, Link } from 'components/core';
import CcpaIcon from 'src/assets/ccpa-icon';

export const DutchiePrivacyFooter = observer(() => {
  const { t } = useTranslation();
  const { isEmbedded } = useUI();
  const { isConsentManagementEnabled } = useConsentManagement();
  const LinkWrapper = isEmbedded ? EmbeddedExternalLink : Link;

  return (
    <Container role={ARIA_ROLES.CONTENT_INFO} className='privacy-policy-link' data-testid='storefront-footer'>
      <FooterItem data-testid='privacy-policy'>
        <Text as={LinkWrapper} href='https://dutchie.com/privacy'>
          {t('footer.privacy', 'Privacy Policy')}
        </Text>
      </FooterItem>
      {isConsentManagementEnabled && (
        <FooterItem data-testid='privacy-choices' id='fides-modal-link'>
          <CcpaIcon />
          <Text>{t('footer.privacy-choices', 'Your Privacy Choices')}</Text>
        </FooterItem>
      )}
    </Container>
  );
});

const Container = styled.div`
  width: var(--kiosk-pro-content-width, 100%);
  height: var(--dcm-privacy-footer-height);
  margin-top: auto;
  border-top: 1px solid var(--dcm-privacy-footer-border-color);
  box-shadow: var(--dcm-privacy-footer-shadow);
  background-color: var(--dcm-privacy-footer-bg);
  z-index: var(--dcm-privacy-footer-z-index);
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterItem = styled.div`
  display: flex;
  align-items: center;

  &:not(:first-child) {
    position: relative;
    margin-left: var(--dcm-privacy-footer-link-gap);
    padding-left: 10px;

    &::before {
      content: '';
      display: block;
      position: absolute;
      top: 2px;
      left: 0px;
      width: 1px;
      height: 16px;
      background-color: var(--dcm-privacy-footer-divider-color);
    }
  }

  svg {
    margin-right: 8px;
  }
`;

const Text = styled.p`
  color: var(--dcm-privacy-footer-text-color);
  cursor: pointer;
  font-size: var(--dcm-privacy-footer-font-size);
  line-height: 20px;
  margin-right: var(--dcm-privacy-footer-link-gap);
  text-decoration: underline;

  :hover {
    color: var(--dcm-privacy-footer-text-hover-color);
  }
`;
